<template>
  <ul class="slm-theme-list__pills">
    <li v-for="pill in pills" :key="pill.id" class="slm-theme-list__pill">
      <a class="slm-theme-list__button slm-link-button" :href="pill.url">
        {{ pill.title }}
      </a>
    </li>
    <li class="slm-theme-list__pill" v-if="pillsLeft > 0">
      <button class="slm-theme-list__button slm-theme-list__button--paginate slm-link-button" @click="handleShowMore">
        Visa fler ({{ pillsLeft }} st)
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: "pills-component",
  computed: {
    pills() {
      return this.$store.state.pills;
    },
    pillsLeft() {
      return this.$store.getters.pillsLeft;
    },
    page() {
      return this.$store.state.page;
    }
  },
  methods: {
    handleShowMore() {
      this.$store.dispatch('showMore', this.page + 1)
    }
  }
};
</script>
